import React from 'react'

export default function NumberOfMeetings(props) {
  const { submissions } = props
  
  return (
    <div>
      <h5 className="profile-header pt-4">Number of meetings I plan to attend every week</h5>
      <div className="row">
        <div className="col-12 p-4">
          <table className="table table-sm table-responsive">
            <thead>
              <tr>
                <th className="col-6">Date Submitted</th>
                <th className="col-6">Number of Meetings</th>
              </tr>
            </thead>
            <tbody>
              {
                submissions.map((submission, index)=>(
                  <tr key={index}>
                    <td>{ moment(submission.created_at).format("MM/DD/YYYY @ h:mmA") }</td>
                    <td>{ submission.get_score}</td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
